import { createContext, ReactNode, useContext } from 'react';
import { TemplateVariableDefinitionDto } from '@/features/dashboard/messageTemplates/types/TemplateVariableDefinitionDto.ts';

const VariablesContext = createContext<TemplateVariableDefinitionDto[]>([]);

export const VariablesProvider = ({
  variables,
  children,
}: {
  variables: TemplateVariableDefinitionDto[];
  children: ReactNode;
}) => (
  <VariablesContext.Provider value={variables}>
    {children}
  </VariablesContext.Provider>
);

export const useVariable = (
  key: string,
): TemplateVariableDefinitionDto | undefined => {
  const variables = useContext(VariablesContext);
  return variables.find((v) => v.key === key);
};
